<script setup>
defineProps({
  badge: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
});

const { tp } = useTypograf();
</script>

<template>
  <div class="card-model">
    <h2 v-if="title" class="card-model__title">
      <span class="card-model__font card-model__font--title">
        {{ tp(title) }}
      </span>
    </h2>

    <div class="card-model__content">
      <div class="card-model__badge">
        <span class="card-model__font card-model__font--badge">
          {{ badge }}
        </span>
      </div>

      <div class="card-model__info">
        <div class="card-model__description">
          <span class="card-model__font card-model__font--description">
            {{ tp(text) }}
          </span>
        </div>

        <img :src="image" alt="" loading="lazy" class="card-model__image" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-model {
  background-color: $color-gray-21;
  padding-block: em(156) em(50);
  padding-inline: em(65) em(76);
  position: relative;

  @include media-breakpoint-mobile {
    padding-block: em(31) em(20);
    padding-inline: em(28) em(23);
  }

  & + & {
    @include media-breakpoint-mobile {
      margin-top: em(14);
    }
  }

  &__title {
    margin-bottom: em(64);

    @include media-breakpoint-desktop {
      position: absolute;
      top: em(44);
      inset-inline-start: em(65);
    }

    @include media-breakpoint-mobile {
      margin-bottom: em(26);
    }
  }

  &__content {
    @include media-breakpoint-desktop {
      display: flex;
      gap: em(39);
    }
  }

  &__badge {
    height: em(40);
    border-radius: em(40);
    padding-block: em(0) em(0);
    padding-inline: em(23) em(23);
    background-color: $color-black;

    color: $color-white;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    @include media-breakpoint-mobile {
      height: em(26);
      margin-bottom: em(20);
      padding-block: em(0) em(0);
      padding-inline: em(10) em(10);
    }
  }

  &__description {
    margin-bottom: em(62);

    @include media-breakpoint-mobile {
      margin-bottom: em(19);
    }
  }

  &__image {
    @include media-breakpoint-desktop {
      width: em(489);
      height: em(435);
    }

    @include media-breakpoint-mobile {
      width: em(299);
      height: auto;
    }
  }

  &__font {
    &--title {
      font-weight: $font-weight-semi-bold;
      font-size: em(40);
      line-height: em(48, 40);

      @include media-breakpoint-mobile {
        font-size: em(20);
      }
    }

    &--badge {
      font-size: em(16);
      font-weight: $font-weight-semi-bold;

      @include media-breakpoint-mobile {
        font-size: em(14);
      }
    }

    &--description {
      font-size: em(25);
      line-height: em(30, 25);
      font-weight: $font-weight-light;

      @include media-breakpoint-mobile {
        font-size: em(16);
      }
    }
  }
}
</style>
